// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-image-bottom[data-v-79e49261]{background-size:cover;background-position:0 100%}p[data-v-79e49261]{font-size:.7rem;font-weight:300}@media(min-width:768px){p[data-v-79e49261]{font-size:.9rem}}@media(min-width:992px){p[data-v-79e49261]{font-size:1rem}}@media print{p[data-v-79e49261]{font-size:12pt}}a[data-v-79e49261]{color:#fff}a[data-v-79e49261]:hover{text-decoration:none}", ""]);
// Exports
module.exports = exports;
